import DesktopWidgetContact from './DesktopWidgetContact';
import MobileWidgetContact from './MobileWidgetContact';
import useFormat from '../../../hooks/useFormat';
import { WidgetComponentProps } from '../../../types/widget';

const WidgetContact = (props: WidgetComponentProps) => {
	const { isMobileFormat } = useFormat();

	return isMobileFormat ? <MobileWidgetContact {...props} /> : <DesktopWidgetContact {...props} />;
};

export default WidgetContact;
